import { Link, useLocation } from 'react-router-dom';
import NavDropdown from './NavDropdown';

/**
 * Platform ▾ tab — site-admin-only dropdown of internal sub-pages.
 * Uses the generic NavDropdown for open/close behavior; styled with the
 * `variant-platform` accent.
 */
export default function PlatformMenu({ section }) {
    const location = useLocation();
    const isActive = section.match(location.pathname);
    const className = `nav-tab variant-platform ${isActive ? 'active' : ''}`.trim();

    return (
        <NavDropdown
            trigger={<button type="button" className={className}>{section.label} ▾</button>}
            panelClassName="platform-panel"
            aria-label="Platform admin"
        >
            <div className="nav-dropdown-header platform">Platform admin</div>
            {section.items.map((item) => (
                <Link key={item.id} to={item.to} className="nav-dropdown-item" role="menuitem">
                    {item.label}
                </Link>
            ))}
        </NavDropdown>
    );
}
